export default "__VITE_ASSET__373f8679__"